var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRteClearFormat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "12px",
    viewBox: "0 0 14 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rich-text-updates",
    transform: "translate(-707.000000, -40.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(225.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-clear-format",
    transform: "translate(482.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.056,0.144 L0.12,1.08 L5.232,6.192 L3.432,10.416 L5.64,10.416 L6.792,7.728 L10.944,11.88 L11.88,10.944 L1.248,0.336 L1.056,0.144 Z M3.048,0.144 L3.048,0.288 L5.112,2.352 L6.864,2.352 L6.336,3.576 L7.872,5.112 L9.048,2.352 L13.296,2.352 L13.296,0.144 L3.048,0.144 Z",
    id: "XMLID_6_"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRteClearFormat);
export default __webpack_public_path__ + "static/media/icon-rte-clear-format.860b44219732376b52265cf9745a65b8.svg";
export { ForwardRef as ReactComponent };